const STORAGE_KEY = 'knowledge_mineru_tasks_v1'
const MAX_TASKS = 30
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000

function safeParse(raw) {
  try {
    const data = JSON.parse(raw)
    return Array.isArray(data) ? data : []
  } catch (e) {
    return []
  }
}

export function loadMineruTasksFromStorage() {
  if (typeof localStorage === 'undefined') return []
  const list = safeParse(localStorage.getItem(STORAGE_KEY) || '[]')
  const now = Date.now()
  return list
    .filter((task) => task && task.localId)
    .filter((task) => {
      const ts = Number(task.updatedAt || task.createdAt) || 0
      return !ts || (now - ts) < MAX_AGE_MS
    })
    .slice(0, MAX_TASKS)
}

export function saveMineruTasksToStorage(tasks) {
  if (typeof localStorage === 'undefined') return
  const list = (tasks || [])
    .filter((task) => task && task.localId)
    .map((task) => ({
      localId: task.localId,
      taskId: task.taskId || null,
      itemId: task.itemId != null ? task.itemId : null,
      fileName: task.fileName || '',
      targetName: task.targetName || '',
      baseName: task.baseName || '',
      dirId: task.dirId != null ? task.dirId : null,
      overwriteId: task.overwriteId || null,
      saveAs: !!task.saveAs,
      sourceUrl: task.sourceUrl || '',
      status: task.status || 'pending',
      progress: Number(task.progress) || 0,
      message: task.message || '',
      queuedAhead: Number(task.queuedAhead) || 0,
      error: task.error || '',
      saved: !!task.saved,
      createdAt: task.createdAt || Date.now(),
      updatedAt: task.updatedAt || Date.now(),
    }))
    .slice(0, MAX_TASKS)
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
  } catch (e) {
    // quota / private mode
  }
}

export function clearMineruTasksStorage() {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    // ignore
  }
}

export function isMineruTaskActive(task) {
  return ['uploading', 'pending', 'processing', 'saving'].includes(task && task.status)
}

export function needsMineruTaskResume(task) {
  if (!task) return false
  if (task.saved) return false
  if (task.status === 'error' && task.error === 'cancelled') return false
  // 已有远端 taskId：可继续轮询 / 取结果并自动保存
  if (task.taskId) {
    return true
  }
  // 还没拿到 taskId 的上传中任务：刷新后无法续传提交中的请求
  return isMineruTaskActive(task)
}
